import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import * as ENV from './env.json';
firebase.initializeApp(ENV.firebase);
